import { STUDENT_ROUTE } from 'app/routing-constants/student-routing.constant';

export const GAME_SECTION_ROUTE = {
  name: 'game-section',
  route(classId: string): string[] {
    return [...STUDENT_ROUTE.LOGGED.route(classId), GAME_SECTION_ROUTE.name];
  },
  DEFAULT: '',
  MAIN: {
    name: 'main',
    route(classId: string): string[] {
      return [...GAME_SECTION_ROUTE.route(classId), GAME_SECTION_ROUTE.MAIN.name];
    }
  },
  BLOCKER_PAGE: {
    name: 'blocker',
    route(classId: string): string[] {
      return [...GAME_SECTION_ROUTE.route(classId), GAME_SECTION_ROUTE.BLOCKER_PAGE.name];
    }
  },
  PARENT_OPT_IN: {
    name: 'parent-opt-in',
    route(classId: string): string[] {
      return [...GAME_SECTION_ROUTE.route(classId), GAME_SECTION_ROUTE.PARENT_OPT_IN.name];
    }
  },
  MARKET: {
    name: 'market',
    route(classId: string): string[] {
      return [...GAME_SECTION_ROUTE.route(classId), GAME_SECTION_ROUTE.MARKET.name];
    }
  },
  EDIT_BOTS: {
    name: 'edit-bots',
    route(classId: string): string[] {
      return [...GAME_SECTION_ROUTE.route(classId), GAME_SECTION_ROUTE.EDIT_BOTS.name];
    }
  },
  GAME_SELECT: {
    name: 'game-select',
    route(classId: string): string[] {
      return [...GAME_SECTION_ROUTE.route(classId), GAME_SECTION_ROUTE.GAME_SELECT.name];
    }
  },
  ARCADE: {
    name: 'arcade',
    route(classId: string): string[] {
      return [...GAME_SECTION_ROUTE.route(classId), GAME_SECTION_ROUTE.ARCADE.name];
    }
  },
  CLASSROOM_GARDEN: {
    name: 'classroom-garden',
    route(classId: string): string[] {
      return [...GAME_SECTION_ROUTE.route(classId), GAME_SECTION_ROUTE.CLASSROOM_GARDEN.name];
    }
  },
  GARDEN_MISSION_START: {
    name: 'garden-mission-start',
    route(classId: string, missionId: string): string[] {
      return [...GAME_SECTION_ROUTE.route(classId), GAME_SECTION_ROUTE.GARDEN_MISSION_START.name, missionId];
    }
  }
};
